import logo from "../assets/images/logo/logo.png";
import logo_cms from "../assets/images/logo/logo_cms.png";
import bg from "../assets/images/background/bg-login.jpg";
import notFound from "../assets/images/notfound/404.png";
import imageEmpty from '../assets/images/imageEmpty.png';
import ExcelFileIcon from '../assets/images/icons/ExcelFileIcon.svg';
export { logo, bg, notFound, logo_cms, imageEmpty, ExcelFileIcon };
